/**
 * Labstep
 *
 * @module components/Filter/Search/Active
 * @desc Active filter component for search query
 */

import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';
import type { FilterSearchActiveProps } from './types';

export const FilterSearchActive: React.FC<
  FilterSearchActiveProps
> = ({ clearParams, searchParams }) => {
  return 'search_query' in searchParams ? (
    <RemoveLabel
      name={searchParams.search_query as string}
      onRemoveClick={
        clearParams && (() => clearParams(['search_query']))
      }
    />
  ) : null;
};
